import { SyntheticEvent, useEffect, useState } from 'react';
import { Segment } from '../core/core';
import Notifications from '../components/Notifications';
import Profile from './Profile';
import ChangePassword from './ChangePassword';
import Subscription from './Subscription';
import styles from './AccountSettings.module.scss';
import utilityStyles from '../SCSS/common/utilityStyles.module.scss';
import segmentStyles from '../SCSS/Segment.module.scss';

const AccountSettings = (): JSX.Element => {
  const [activeTab, setActiveTab] = useState(0);

  const handleClick = (_: SyntheticEvent<HTMLButtonElement>, index: number) => {
    setActiveTab(index);
  };

  const tabLabels = ['Profile', 'Change Password', 'Notifications', 'Subscription'];

  useEffect(() => {
    setActiveTab(0);
  }, [setActiveTab]);

  return (
    <div className={`${styles.accountSettingsContainer} ${utilityStyles.clearfix}`}>
      <div className={utilityStyles.pageTitleGap} />
      <Segment className={utilityStyles.line}>
        <div className={`${segmentStyles.moduleTitle} vcenter`}>Account Settings</div>
      </Segment>
      <Segment className={utilityStyles.line}>
        <div className={styles.container}>
          <section className={styles.formLeft}>
            {activeTab === 0 && <Profile />}
            {activeTab === 1 && <ChangePassword />}
            {activeTab === 2 && <Notifications />}
            {activeTab === 3 && <Subscription />}
          </section>
          <section className={styles.formRight}>
            {tabLabels.map((tabName, index) => {
              return (
                <div key={tabName} className={styles.menuItem}>
                  <button
                    role='tab'
                    className={activeTab === index ? styles.activeTab : ''}
                    onClick={(e) => handleClick(e, index)}
                  >
                    {tabName}
                  </button>
                </div>
              );
            })}
          </section>
        </div>
      </Segment>
    </div>
  );
};

export default AccountSettings;
